import React, { createContext, useContext } from 'react'

/**
 * Hidden positions are left out of the map. With "show hidden" on in the position filter they are
 * drawn greyed out instead, so they can be found and unhidden.
 */
const ShowHiddenPositionsContext = createContext(false)

export const ShowHiddenPositionsProvider: React.FC<{ showHidden?: boolean; children: React.ReactNode }> = ({
  showHidden,
  children,
}) => <ShowHiddenPositionsContext.Provider value={!!showHidden}>{children}</ShowHiddenPositionsContext.Provider>

export const useShowHiddenPositions = () => useContext(ShowHiddenPositionsContext)
